// Tiny localStorage layer for remembering "my last token" PER shop, PER day.
// Used by the "Already booked today?" card on the booking page so a returning
// visitor can re-open their live ticket with one tap.
//
// Storage key:   aibox:last-token:<shop-slug>
// Stored value:  { tokenNumber, whatsapp, ts (ISO date string) }
//
// Entries are considered stale once the calendar date changes — token numbers
// reset daily server-side via `next_token_number()`.

const KEY = (slug) => `aibox:last-token:${slug}`;

function todayKey() {
  return new Date().toISOString().slice(0, 10); // "YYYY-MM-DD"
}

export function saveLastToken(slug, { tokenNumber, whatsapp }) {
  if (!slug || !tokenNumber) return;
  try {
    localStorage.setItem(
      KEY(slug),
      JSON.stringify({
        tokenNumber: String(tokenNumber),
        whatsapp: whatsapp || "",
        day: todayKey(),
      })
    );
  } catch {/* private-mode browsers etc. */}
}

export function getLastToken(slug) {
  if (!slug) return null;
  try {
    const raw = localStorage.getItem(KEY(slug));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (parsed.day !== todayKey()) return null; // stale
    return parsed;
  } catch {
    return null;
  }
}

export function clearLastToken(slug) {
  if (!slug) return;
  try { localStorage.removeItem(KEY(slug)); } catch {/* ignore */}
}
